export default __webpack_public_path__ + "static/media/react.b9921a7c.svg";